import React, { FC } from 'react'
import cx from 'classnames'
import { DivProps } from '@commonTypes'
import { Intent } from '@blueprintjs/core'
import css from './list.module.scss'

export function List({
  title,
  children,
  style,
  intent,
}: {
  title?: string
  children: React.ReactNode | React.ReactNodeArray
  style?: React.CSSProperties
  intent?: Intent
}) {
  return (
    <Container intent={intent} style={style}>
      {title && <div className={css.title}>{title}</div>}
      {children}
    </Container>
  )
}

export const Item: FC<React.PropsWithChildren<DivProps>> = ({ className, ...props }) => {
  return <div className={cx(css.item, className)} {...props} />
}

type Props = DivProps & {
  intent?: Intent
}

const Container: FC<React.PropsWithChildren<Props>> = ({ intent, className, style, ...props }) => {
  return (
    <div
      className={cx(css.container, className)}
      style={{ borderColor: intent === Intent.DANGER ? 'red' : 'var(--border-color)', ...style }}
      {...props}
    />
  )
}
